module.exports = __webpack_public_path__ + "img/ss_blue-03.eff71998.jpg";